/**
 * in this module there are the functions to:
 *  - setup a cookie / user preferences
 *  - get the cookie values
 *  - check if a cookie exist
 *  - if exist center the map on the last position
 */

/**
 * we only export the checkCookie function
 *  to work need some parameter
 * mapView = the map view
 * resolutions = the map resolutions array
 * check the alwaysmodal property
 *  - we check this property to display alway the getting started/help modal
  */
import functions from './functions'
import marker from '../common/marker'

var pageconfig

try {
  pageconfig = JSON.parse($('#pageconfig').val())
} catch {
  pageconfig = ''
}

let Cookies = require('js-cookie')

/**
 * set the traffweb cookie with:
 *  - last zoom lv
 *  - last map center
 *  - expire date 1 week
 */

const setUserPrefs = (mapView) => {
  let cookieName = location.href.split('/').slice(-2)
  cookieName.pop()
  const curZ = mapView.getView().getResolution()
  const mapCen = mapView.getView().getCenter()

  let cachelayer = $('.cachetheme.selectedZoomstack').attr('data-theme') === null ? pageconfig.cachelayer : 'Zoomstack:'+$('.cachetheme.selectedZoomstack').attr('data-theme')
  let cookieStr = `#${mapCen[0]}#${mapCen[1]}#${curZ}#${cachelayer}`
  Cookies.set(`traffweb#${cookieName}`, cookieStr, {
    expires: 7,
    domain: `${window.location.host}`,
    path: `${window.location.pathname}`,
    secure: true,
    httponly: false,
    samesite: 'Strict',
  })
}

/**
 * get the user preferences from cookie
 * extracts the user last position
 * last zoom, map centre
 */

const getUserPrefs = () => {
  let cookieName = location.href.split('/').slice(-2)
  cookieName.pop()

  let cookieCrumbs = Cookies.get(`traffweb#${cookieName}`)

  if (cookieCrumbs === undefined) {
    return null
  }
  else {
    cookieCrumbs = cookieCrumbs.substring((cookieCrumbs.indexOf('#') + 1), cookieCrumbs.length)
    cookieCrumbs = cookieCrumbs.replace(/#/g, ',')
    return cookieCrumbs
  }
}

/**
 * check if the cookie is present and:
 *  - display the correct header/button in the help modal
 *  - move the map based on the cookie
 *  - move the map based on the URL ?defpos
 */

const checkCookie = (mapView, themeSel) => {
  const checkPos = getUserPrefs()
  let setPos = ''
  if (checkPos) {
    setPos = getUserPrefs().split(',')

    /**
     * move the map to the last position
     */

    mapView.getView().setResolution(parseFloat(setPos[2]))
    mapView.getView().centerOn([parseFloat(setPos[0]), parseFloat(setPos[1])], mapView.getSize(), [($('#map').innerWidth() / 2), ($('#map').innerHeight() / 2)])

    /**
     * check if the customer want the modal to appear always at every page load
     */

    if (pageconfig.alwaysmodal && themeSel === false) {
      // disable the escape event at first loading

      if (pageconfig.appname.type === 'psa' && !pageconfig.private) {
      } else {
        $('#help').modal({
            backdrop: 'static',
            keyboard: false
        })
      }
      /**
       * show the correct header and button
       */

      $('#privaccept').show()
      $('.helpStarter').show()
      $('#privpolicy').show()
      $('.privClose').hide()
      $('.helpNormal').hide()
      $('#helpClose').hide()

      /**
       *  - show the help modal
       *  - recreate the modal on dismiss and enable the escape event again
       * Note the `one` binding
       */
      if (pageconfig.appname.type === 'psa' && !pageconfig.private) {
      } else {
        $('#help').modal('show')
        $('#help').one('hidden.bs.modal', () => {
            $('#help').modal('dispose')
        })
      }

    }
    else {
      /**
       * if the cookie is present and alwaysmodal false, hide the help modal
       */

      $('#help').modal('hide')

      /**
       * show the correct header and button
       */

      $('#privaccept').hide()
      $('.helpStarter').hide()
      $('#privpolicy').hide()
      $('.privClose').show()
      $('.helpNormal').show()
      $('#helpClose').show()
    }
  }
  /**
   * else if the cookie is not present
   */

  else {
    /**
     * show the correct header and button
     */

    $('#privaccept').hide()
    $('.helpStarter').hide()
    $('#privpolicy').hide()
    $('.privClose').show()
    $('.helpNormal').show()
    $('#helpClose').show()

    /**
     *  - show the help modal
     *  - recreate the modal on dismiss and enable the escape event again
     * Note the `one` binding
     */
    if (pageconfig.appname.type === 'psa' && !pageconfig.private) {

    } else {
        /**
         * disable the escape evente at first loading
         */

        $('#help').modal({
            backdrop: 'static',
            keyboard: false
        })
        if (themeSel !== false) {
            $('#help').modal('show')
        }
        $('#help').one('hidden.bs.modal', () => {
        $('#help').modal('dispose')
        })
    }
    /**
     * set the cookie with the value in the fixed.json
     */
    if (mapView !== undefined) {
      setUserPrefs(mapView)
    }
    /**
     * there is no need to move the map as it will use the values in the fixed.json
     */
  }

  /**
   * check if there are parameters in the URL to move the map
   * e.g. ?defpos=508000,181500,1
   */

  let urlpos = window.location.search.replace('?', '')

  /**
   * check if the defpos parameter is present in the URL
   */

  if (urlpos.search('defpos') > -1) {
    /**
     * split the parameter by =
     * take the first element in the array
     * split again by , to have the final array to use for moving the map
     */

    setPos = urlpos.split('=')[1].split(',')

    /**
     * we check if splitting by & you have something back
     * this code will work when you have multiple parameters in the URL
     * e.g. defpos + legend group or defpos + suspid
     */

    if (setPos[2].split('&')[1]) {
      setPos[2] = setPos[2].split('&')[0]
    }

    /**
     * finally move the map accordingly if defpos is present in the URL
     */

    mapView.getView().setResolution(mapView.getView().getResolutions()[parseFloat(setPos[2])])
    mapView.getView().centerOn([parseFloat(setPos[0]), parseFloat(setPos[1])], mapView.getSize(), [($('#map').innerWidth() / 2), ($('#map').innerHeight() / 2)])
  }


  /**
   * check if the markpos parameter is present in the URL
   */

   if (urlpos.search('markpos') > -1) {

    /**
     * split the parameter by =
     * take the first element in the array
     * split again by , to have the final array to use for moving the map
     */

    setPos = urlpos.split('=')[1].split(',')

    /**
     * we check if splitting by & you have something back
     * this code will work when you have multiple parameters in the URL
     * e.g. markpos + legend group or markpos + suspid
     */

    if (setPos[2].split('&')[1]) {
      setPos[2] = setPos[2].split('&')[0]
    }

    /**
     * finally move the map accordingly if markpos is present in the URL
     */

    mapView.getView().setResolution(mapView.getView().getResolutions()[parseFloat(setPos[2])])
    mapView.getView().centerOn([parseFloat(setPos[0]), parseFloat(setPos[1])], mapView.getSize(), [($('#map').innerWidth() / 2), ($('#map').innerHeight() / 2)])
    var mLayer = marker.addMarkFoam(parseFloat(setPos[0]), parseFloat(setPos[1]),marker.markerSource())
    mapView.addLayer(mLayer)
  }

  /**
   * check if in the URL you have the fref parameter
   * FRA website
   */

  if (urlpos.search('fref') > -1) {
    /**
     * get the fref ID
     */

    let sFindID = urlpos.replace('fref=', '')

    /**
     * initialize the searchUrl to empty
     * check if it's a localhost environment
     * popuplate the path to the php file accordingly
     */

    /**
     * create the json data
     */

     let theData = '{"findfault": "' + sFindID + '", "findstamp": "", "findstat": "1,2,3"}'


     if (pageconfig.appname.type === 'fra' && pageconfig.private) {
        /**
         * send an ajax reuqest
         */

        $.ajax({
        url: '/traffweb/fra-find',
        type:"POST",
        data: {
            jdata: theData
        },
        beforeSend: function beforeSend(xhr) {
            xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
        }
        })
        .done((data) => {
            /**
             * parse the result
             */

            data = JSON.parse(data)

            /**
             * check if the response is empty
             * display an error
             */

            let zoom = mapView.getView().getResolutions()
            mapView.getView().setResolution(zoom[zoom.length - 1])
            mapView.getView().centerOn([parseFloat(data[0].easting), parseFloat(data[0].northing)], mapView.getSize(), [($(window).innerWidth() / 2), ($(window).innerHeight() / 2)])

            /**
                * check if it's a mobile device
                * hide the tools menu
                */

            if (functions.mobileTabletView()) {
                $('#dropdownTools').trigger('click')
            }

        }) // end done
        .fail(function (jqxhr, textStatus, error) {
            const err = `${textStatus}, ${error}`
            alert(`THEURLS Request Failed: ${err}`)
        })
     }
  }
  /**
    * end find if
    */

  /**
   * check if in the URL you have the suspid parameter
   * PSA staff website
   * http://demo.localhost/traffweb/7/ParkingSuspensionStaff?suspid=x3O4wyJ3y3FGLCK6iKqvlL7ddTU9Jb2J&expdate=2088-6-7
   */

  if (urlpos.search('suspid') > -1) {
    /**
     * get the suspid ID
     */

    let sFindID = urlpos.replace('suspid=', '')
    let theData = '{"findsusp": "' + sFindID + '", "findstamp": ""}'

    /**
     * send an ajax reuqest
     */
    if (pageconfig.appname.type === 'psa' && pageconfig.private) {

        $.ajax({
        url: '/traffweb/psa-find',
        type:"POST",
        data: {
        jdata: theData
        },
        beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
        }
        })
        .done((data) => {

            data = JSON.parse(data)

            let zoom = mapView.getView().getResolutions()
            mapView.getView().setResolution(zoom[zoom.length - 1])
            mapView.getView().centerOn([parseFloat(data[0].easting), parseFloat(data[0].northing)], mapView.getSize(), [($(window).innerWidth() / 2), ($(window).innerHeight() / 2)])

            /**
             * check if it's a mobile device
             * hide the tools menu
             */

            if (functions.mobileTabletView()) {
                $('#dropdownToolsMobile').trigger('click')
            }

        }) // end done
        .fail(function (jqxhr, textStatus, error) {
            const err = `${textStatus}, ${error}`
            alert(`THEURLS Request Failed: ${err}`)
        })
    } else if (pageconfig.appname.type === 'psa' && !pageconfig.private) {

     setPos = urlpos.split('=')[1].split(',')

     if (setPos[2].split('&')[1]) {
       setPos[2] = setPos[2].split('&')[0]
     }

     mapView.getView().setResolution(mapView.getView().getResolutions()[parseFloat(setPos[2])])
     mapView.getView().centerOn([parseFloat(setPos[0]), parseFloat(setPos[1])], mapView.getSize(), [($('#map').innerWidth() / 2), ($('#map').innerHeight() / 2)])     }
  }

  /**
   * event listener to update the user preferences when the map move
   * the zoom event doesn't work and it's included in the moveend event
   */
  if (mapView !== undefined) {
    mapView.on('moveend', () => {
        if (pageconfig.appname.type !== 'psa' && !pageconfig.private) {
            setUserPrefs(mapView)
        }
    })
  }
} // end checkCookie


/**
 * EXPORT
 */

export default {
  checkCookie,
  getUserPrefs
}
